var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#F8FBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.88 34.24C17.32 34.24 14.9 31.16 14.9 26.54C14.9 21.92 17.3 18.86 20.86 18.86C24.46 18.86 26.84 21.94 26.84 26.54C26.84 31.14 24.48 34.24 20.88 34.24ZM20.88 31.92C23.02 31.92 24.34 29.88 24.34 26.54C24.34 23.22 23.02 21.18 20.86 21.18C18.74 21.18 17.42 23.22 17.42 26.54C17.42 29.86 18.76 31.92 20.88 31.92ZM31.6105 34V21.26H28.8105V19.12L34.1505 19.1V34H31.6105Z",
    fill: "#0C78F1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.c41fb1e9e7e6fa9b54fa617f848707bd.svg";
export { ForwardRef as ReactComponent };